module.exports = __webpack_public_path__ + "img/19.24c11c94.png";